<div class="SLV2-main-wrapper">
    
    <div class="SLV2-body-section">

        <div class="SLV2-section-wrap SLV2-page-header-area">
            <div class="SLV2-page-header-lft">
                <button class="SLV2-header-text-button" (click)="navigateToChapterPage()">
                    <img src="selflearnv2-ui/assets/img/self-learn-v2/banner-back-arrow.svg" />
                    <span>All topic's summary</span>
                </button>
            </div>
        </div>


        <div class="SLV2-section-wrap">
            <div class="row SLV2-sm-gap SLV2-leading-zero-list">
                <div class="col-xl-3 col-lg-4 col-md-6" *ngFor="let item of topicCardList">
                    <app-topic-summary-card [topicName]="item.topicName" [flashcardData]="item" [allTopicsSummeryProgress]="allTopicsSummeryProgress"></app-topic-summary-card>
                </div>
            </div>
        </div>


    </div>
</div>